import { computed, signal } from "@preact/signals";
import type { Ec2RawInstance, Environment, VersionInfo } from "../types";

export const solutionInput = signal("");
export const activeSolution = signal("");
export const ec2Cache = signal<Ec2RawInstance[] | null>(null);

export const solutionIndex = computed(() => {
  const index = new Map<string, Set<Environment>>();
  for (const instance of ec2Cache.value ?? []) {
    const tags = instance.Tags ?? [];
    const solution = tags.find((t) => t.Key === "DIGHUM_SOLUTION")?.Value;
    const env = tags.find((t) => t.Key === "DIGHUM_ENVIRONMENT")?.Value as Environment | undefined;
    if (!solution || !env) continue;
    if (!index.has(solution)) {
      index.set(solution, new Set());
    }
    index.get(solution)!.add(env);
  }
  return index;
});

export type Page = "demand" | "ssm" | "kiosks";
export const activePage = signal<Page>("demand");

export const headVersion = signal<VersionInfo | null>(null);
export const selectedVersion = signal<VersionInfo | null>(null);
